import { Capacitor } from "@capacitor/core";

let productionServer = process.env.REACT_APP_BACKEND_SERVER;
let devServer = "http://192.168.23.226:8080";

function getServerURL() {
  let platform = Capacitor.getPlatform();

  devServer = `http://${window.location.hostname}:8080`;
  // if (platform == "web") devServer = "http://localhost:8080";

  let base = productionServer || window.location.origin;

  if (window.location.origin.indexOf("localhost") !== -1) {
    base = devServer;
  }

  if (window.location.origin.indexOf("192.168") !== -1) {
    base = devServer;
  }

  if (platform !== "web") {
    //Is case of production in app the url is https://localhost
    //So if there is http in the android app it is likely using livereload
    //otherwise it is a build apk, and in the build apk we will
    //use hosted backend
    let isDev = window.location.href.startsWith("http://");
    if (isDev) {
      base = devServer;
    } else {
      base = productionServer;
    }
  }

  // Prevent mixed-content failures when the app is served over HTTPS.
  if (
    platform === "web" &&
    window.location.protocol === "https:" &&
    typeof base === "string" &&
    base.startsWith("http://")
  ) {
    base = window.location.origin;
  }

  // console.log(base);
  return base;
}

export default getServerURL;
